/*
 * @Author: Ben 550461173@qq.com
 * @Date: 2024-07-26 15:27:51
 * @LastEditors: Ben 550461173@qq.com
 * @LastEditTime: 2024-07-26 18:30:00
 * @FilePath: \digital-ocms-kacontent-mobile\src\api\modules\user.ts
 * @Description:  */
import { http } from '@/utils/http/axios'
import { Apis } from '@/enums/apis'
import { RequestEnum } from '@/enums/httpEnum'
import type { IUserState } from '@/typings/user'

/**
 * 用户授权
 * @param code  授权码
 * @param debug 是否debug调试
 * @returns     授权结果
 */
export async function userAuth(code: string, debug: boolean, digitalId: string) {
    return await http.request<IUserState>({
        url: Apis.Auth,
        method: RequestEnum.GET,
        params: { code, debug, digitalId },
    })
}

/**
 * 用户邀请码
 * @param isid 邀请码
 */
export async function userReferrer(isid: string) {
    return await http.request<string>({
        url: Apis.ReferrerCode,
        method: RequestEnum.GET,
        params: { isid },
    })
}

/**
 * 保存用户日志
 * @param data 日志数据
 */
export async function saveUserLog(data: any) {
    return await http.request<string>({
        url: Apis.SaveUserLog,
        method: RequestEnum.POST,
        data,
    })
}

/**
 * 签到
 */
export async function SignIn() {
    return await http.request<number>({
        url: Apis.PointSignIn,
        method: RequestEnum.GET,
    })
}

export async function SignInRecords() {
    return await http.request<string>({
        url: Apis.SignInRecords,
        method: RequestEnum.GET,
    })
}

export async function TaskList() {
    return await http.request<any>({
        url: Apis.TaskList,
        method: RequestEnum.GET,
    })
}

export async function TotalPoints() {
    return await http.request<any>({
        url: Apis.TotalPoints,
        method: RequestEnum.GET,
    })
}

export async function PointSent(data: any) {
    return await http.request<any>({
        url: `${Apis.PointSent}?eventCode=${data.eventCode}&businessId=${data.businessId || ''}&businessType=${data.businessType || ''}`,
        method: RequestEnum.POST,
    })
}

export async function AnnualTotalPoints() {
    return await http.request<any>({
        url: Apis.AnnualTotalPoints,
        method: RequestEnum.GET,
    })
}
